module.exports = __webpack_public_path__ + "static/media/camera.0db2a468.svg";